import { baseApi } from '@/services'
import { AtypicalityCheck, AtypicalityCheckCalcs } from '@/types/unlock'

export const atypicalityCheckApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAtypicalityCheckByApplication: builder.query<AtypicalityCheck, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/atypicality-check/`,
      providesTags: ['AtypicalityCheckV2'],
    }),
    getAtypicalitCheckCalcs: builder.query<Partial<AtypicalityCheckCalcs>, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/atypicality-check/calcs/`,
      providesTags: ['AtypicalityCheckV2', 'AtypicalityCheckCalcs'],
    }),
    updateAtypicalityCheckByApplication: builder.mutation<
      AtypicalityCheck,
      { applicationUUID: string; atypicalityCheck: Partial<AtypicalityCheck> }
    >({
      query: ({ applicationUUID, atypicalityCheck }) => ({
        url: `v2/applications/${applicationUUID}/atypicality-check/${atypicalityCheck.uuid}/`,
        method: 'PATCH',
        body: atypicalityCheck,
      }),
      invalidatesTags: [
        'AutomatedApplicationExceptions',
        'Escalations',
        'AtypicalityCheckCalcs',
        'AtypicalityCheckV2',
        'Application',
      ],
    }),
  }),
})

export const {
  useGetAtypicalityCheckByApplicationQuery,
  useGetAtypicalitCheckCalcsQuery,
  useUpdateAtypicalityCheckByApplicationMutation,
} = atypicalityCheckApi
